import { LookupStatus } from "../../common/LookupStatusIndicator";
import { SavedSearchLookupStatusCode } from "../constants";

export const getLookupStatusFromCode = (lookupStatus?: SavedSearchLookupStatusCode): LookupStatus => {
  switch (lookupStatus) {
    case SavedSearchLookupStatusCode.Failed:
      return LookupStatus.Error;
    case SavedSearchLookupStatusCode.Queued:
    case SavedSearchLookupStatusCode.InProgress:
      return LookupStatus.Busy;
    default:
      return LookupStatus.Completed;
  }
};

export const getLookupStatusLabel = (lookupStatus?: string): string => {
  switch (lookupStatus) {
    case SavedSearchLookupStatusCode.Failed:
      return "Failed";
    case SavedSearchLookupStatusCode.Queued:
    case SavedSearchLookupStatusCode.InProgress:
      return "In Progress";
    default:
      return "";
  }
};